<template>

  <!-- Mobile -->
  <div class="timeline-container-mobile mx-3 d-block d-lg-none">
    <h2 class="timeline-title-mobile heading">Détail du travelski night express</h2>
    
    <div class="d-flex mb-1">
      <div class="timeline-visual-mobile d-flex flex-column align-items-center me-3">
        <div class="timeline-point-mobile"></div>
        <div class="timeline-line-mobile line-solid-mobile flex-grow-1"></div>
      </div>
      <div class="timeline-content-mobile pb-2">
        <div class="timeline-text-mobile"><strong>Départ vendredi</strong> soir de Paris</div>
        <div class="custom-badge-mobile badge-train-mobile">
          <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.28809 14.35H15.4363V14.3942C15.4363 15.3086 14.6946 16.0503 13.7802 16.0503H6.94417C6.02975 16.0503 5.28809 15.3086 5.28809 14.3942V14.35Z" fill="#1E53BC"/>
            <path d="M6.96318 15.7891L4.16797 19" stroke="#1E53BC" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
            <path d="M13.7603 15.7891L16.5555 19" stroke="#1E53BC" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
            <path d="M5.03467 17.7284H15.6894" stroke="#1E53BC" stroke-width="1.5" stroke-miterlimit="10"/>
            <path d="M7.94536 2.43915H12.798C14.1203 2.43915 15.2477 3.48345 15.4633 4.90704L16.6856 11.4028C16.957 13.1991 15.688 14.8305 14.0203 14.8305H6.70232C5.03065 14.8305 3.76034 13.1913 4.0383 11.3924L5.28134 4.89794C5.50085 3.47826 6.62698 2.43915 7.94536 2.43915V2.43915Z" stroke="#1E53BC" stroke-width="1.5" stroke-miterlimit="10"/>
            <path d="M13.2422 2.70026L7.48032 2.70026V2.65609C7.48032 1.74168 8.22199 1.00001 9.1364 1.00001L11.5861 1.00001C12.5005 1.00001 13.2422 1.74168 13.2422 2.65609V2.70026V2.70026Z" fill="#1E53BC"/>
            <path d="M7.23102 13.0862C7.83862 13.0862 8.33118 12.5936 8.33118 11.986C8.33118 11.3784 7.83862 10.8859 7.23102 10.8859C6.62342 10.8859 6.13086 11.3784 6.13086 11.986C6.13086 12.5936 6.62342 13.0862 7.23102 13.0862Z" fill="#1E53BC"/>
            <path d="M13.5113 13.0862C14.1189 13.0862 14.6114 12.5936 14.6114 11.986C14.6114 11.3784 14.1189 10.8859 13.5113 10.8859C12.9037 10.8859 12.4111 11.3784 12.4111 11.986C12.4111 12.5936 12.9037 13.0862 13.5113 13.0862Z" fill="#1E53BC"/>
            <path d="M4.45654 9.53764H16.2686L15.7075 4.74994H5.37486L4.45654 9.53764Z" fill="#1E53BC"/>
            <path d="M10.3623 4.43817V9.53761" stroke="white" stroke-width="1.5" stroke-miterlimit="10"/>
          </svg>
          Travelski night express
        </div>
      </div>
    </div>
    
    <div class="d-flex mb-1">
      <div class="timeline-visual-mobile d-flex flex-column align-items-center me-3">
        <div class="timeline-point-mobile"></div>
        <div class="timeline-line-mobile line-dotted-mobile flex-grow-1"></div>
      </div>
      <div class="timeline-content-mobile pb-2">
        <div class="timeline-text-mobile"><strong>Arrivée samedi</strong> matin à la gare</div>
        <div class="custom-badge-mobile badge-transfer-mobile">
          <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.7196 2H4.90152C3.96864 2 3.2124 2.75624 3.2124 3.68911V14.9472C3.2124 15.8801 3.96864 16.6363 4.90152 16.6363H14.7196C15.6525 16.6363 16.4087 15.8801 16.4087 14.9472V3.68911C16.4087 2.75624 15.6525 2 14.7196 2Z" stroke="#0D141B" stroke-width="1.5" stroke-miterlimit="10"/>
            <path d="M17 5.53626V8.53625H19V5.53626H17Z" stroke="#0D141B" stroke-width="1.5" stroke-linejoin="round"/>
            <path d="M1 5.53626L1 8.53625H3V5.53626H1Z" stroke="#0D141B" stroke-width="1.5" stroke-linejoin="round"/>
            <path d="M16.4087 4.81915H3.2124V11.1941H16.4087V4.81915Z" fill="#0D141B"/>
            <path d="M12.2344 16.7516H14.5422V17.9717C14.5422 18.5798 14.048 19.0726 13.4413 19.0726H13.3366C12.7285 19.0726 12.2357 18.5785 12.2357 17.9717V16.7516H12.2344Z" stroke="#0D141B" stroke-width="1.5" stroke-miterlimit="10"/>
            <path d="M5.0166 16.7516H7.3244V17.9717C7.3244 18.5798 6.83025 19.0726 6.22349 19.0726H6.11883C5.51075 19.0726 5.01793 18.5785 5.01793 17.9717V16.7516H5.0166Z" stroke="#0D141B" stroke-width="1.5" stroke-miterlimit="10"/>
            <path d="M9.81104 4.36609V11.7134" stroke="white" stroke-width="1.5" stroke-miterlimit="10"/>
            <path d="M8.77783 13.7086H10.8737" stroke="#0D141B" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
            <path d="M6.04206 14.9181C6.71007 14.9181 7.2516 14.3766 7.2516 13.7086C7.2516 13.0406 6.71007 12.499 6.04206 12.499C5.37405 12.499 4.83252 13.0406 4.83252 13.7086C4.83252 14.3766 5.37405 14.9181 6.04206 14.9181Z" fill="#0D141B"/>
            <path d="M13.6094 14.9181C14.2775 14.9181 14.819 14.3766 14.819 13.7086C14.819 13.0406 14.2775 12.499 13.6094 12.499C12.9414 12.499 12.3999 13.0406 12.3999 13.7086C12.3999 14.3766 12.9414 14.9181 13.6094 14.9181Z" fill="#0D141B"/>
          </svg>
          Transfert jusqu'à l'hébergement
        </div>
      </div>
    </div>
    
    <div class="d-flex mb-1">
      <div class="timeline-visual-mobile d-flex flex-column align-items-center me-3">
        <div class="timeline-point-mobile"></div>
        <div class="timeline-line-mobile line-solid-mobile flex-grow-1"></div>
      </div>
      <div class="timeline-content-mobile pb-2">
        <div class="timeline-text-mobile"><strong>Dépose des valises</strong> et récupération des skis</div>
        <div class="custom-badge-mobile badge-stay-mobile">
          <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.28955 6.72662L17.7743 9.89399" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
            <path d="M3.89804 5.8291L3.32324 8.2443" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
            <path d="M1.4668 11.8024L14.163 18.2985C15.0525 18.7506 16.1354 18.5359 16.7862 17.7784L17.5797 16.8556" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
            <path d="M16.9114 4.51811C17.8829 4.51811 18.6705 3.73056 18.6705 2.75906C18.6705 1.78756 17.8829 1 16.9114 1C15.9399 1 15.1523 1.78756 15.1523 2.75906C15.1523 3.73056 15.9399 4.51811 16.9114 4.51811Z" fill="white"/>
            <path d="M14.6683 5.08755C14.2615 4.12733 13.1533 3.67923 12.1931 4.08599L8.63096 5.59566C7.72809 5.97841 7.27866 6.9813 7.56672 7.8975C7.59873 8.03087 7.65474 8.1589 7.73476 8.27759C7.81344 8.41495 7.90813 8.54031 8.01482 8.64967L10.2313 11.5583L7.44536 12.6732C6.84389 12.9133 6.55183 13.5961 6.79322 14.1962C6.97592 14.655 7.41602 14.9337 7.88146 14.9337C8.02682 14.9337 8.17352 14.9071 8.31622 14.8497L12.5638 13.1507C12.9079 13.0133 13.1666 12.7212 13.2613 12.3625C13.356 12.0051 13.276 11.6223 13.0453 11.3329L11.0075 8.68968L13.6681 7.56143C14.6283 7.15467 15.0764 6.04643 14.6696 5.08621L14.6683 5.08755Z" fill="white"/>
          </svg>
          Séjour du samedi au samedi
        </div>
      </div>
    </div>

    <div class="d-flex mb-1">
      <div class="timeline-visual-mobile d-flex flex-column align-items-center me-3">
        <div class="timeline-point-mobile"></div>
        <div class="timeline-line-mobile line-dotted-mobile flex-grow-1"></div>
      </div>
      <div class="timeline-content-mobile pb-2">
        <div class="timeline-text-mobile">Skiez jusqu'à la dernière minute</div>
        <div class="custom-badge-mobile badge-transfer-mobile">
          <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.7196 2H4.90152C3.96864 2 3.2124 2.75624 3.2124 3.68911V14.9472C3.2124 15.8801 3.96864 16.6363 4.90152 16.6363H14.7196C15.6525 16.6363 16.4087 15.8801 16.4087 14.9472V3.68911C16.4087 2.75624 15.6525 2 14.7196 2Z" stroke="#0D141B" stroke-width="1.5" stroke-miterlimit="10"/>
            <path d="M17 5.53626V8.53625H19V5.53626H17Z" stroke="#0D141B" stroke-width="1.5" stroke-linejoin="round"/>
            <path d="M1 5.53626L1 8.53625H3V5.53626H1Z" stroke="#0D141B" stroke-width="1.5" stroke-linejoin="round"/>
            <path d="M16.4087 4.81915H3.2124V11.1941H16.4087V4.81915Z" fill="#0D141B"/>
            <path d="M12.2344 16.7516H14.5422V17.9717C14.5422 18.5798 14.048 19.0726 13.4413 19.0726H13.3366C12.7285 19.0726 12.2357 18.5785 12.2357 17.9717V16.7516H12.2344Z" stroke="#0D141B" stroke-width="1.5" stroke-miterlimit="10"/>
            <path d="M5.0166 16.7516H7.3244V17.9717C7.3244 18.5798 6.83025 19.0726 6.22349 19.0726H6.11883C5.51075 19.0726 5.01793 18.5785 5.01793 17.9717V16.7516H5.0166Z" stroke="#0D141B" stroke-width="1.5" stroke-miterlimit="10"/>
            <path d="M9.81104 4.36609V11.7134" stroke="white" stroke-width="1.5" stroke-miterlimit="10"/>
            <path d="M8.77783 13.7086H10.8737" stroke="#0D141B" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
            <path d="M6.04206 14.9181C6.71007 14.9181 7.2516 14.3766 7.2516 13.7086C7.2516 13.0406 6.71007 12.499 6.04206 12.499C5.37405 12.499 4.83252 13.0406 4.83252 13.7086C4.83252 14.3766 5.37405 14.9181 6.04206 14.9181Z" fill="#0D141B"/>
            <path d="M13.6094 14.9181C14.2775 14.9181 14.819 14.3766 14.819 13.7086C14.819 13.0406 14.2775 12.499 13.6094 12.499C12.9414 12.499 12.3999 13.0406 12.3999 13.7086C12.3999 14.3766 12.9414 14.9181 13.6094 14.9181Z" fill="#0D141B"/>
          </svg>
          Transfert jusqu'à la gare
        </div>
      </div>
    </div>
    
    <div class="d-flex mb-1">
      <div class="timeline-visual-mobile d-flex flex-column align-items-center me-3">
        <div class="timeline-point-mobile"></div>
        <div class="timeline-line-mobile line-solid-mobile flex-grow-1"></div>
      </div>
      <div class="timeline-content-mobile pb-2">
        <div class="timeline-text-mobile"><strong>Départ samedi</strong> soir de la station</div>
        <div class="custom-badge-mobile badge-train-mobile">
          <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.28809 14.35H15.4363V14.3942C15.4363 15.3086 14.6946 16.0503 13.7802 16.0503H6.94417C6.02975 16.0503 5.28809 15.3086 5.28809 14.3942V14.35Z" fill="#1E53BC"/>
            <path d="M6.96318 15.7891L4.16797 19" stroke="#1E53BC" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
            <path d="M13.7603 15.7891L16.5555 19" stroke="#1E53BC" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
            <path d="M5.03467 17.7284H15.6894" stroke="#1E53BC" stroke-width="1.5" stroke-miterlimit="10"/>
            <path d="M7.94536 2.43915H12.798C14.1203 2.43915 15.2477 3.48345 15.4633 4.90704L16.6856 11.4028C16.957 13.1991 15.688 14.8305 14.0203 14.8305H6.70232C5.03065 14.8305 3.76034 13.1913 4.0383 11.3924L5.28134 4.89794C5.50085 3.47826 6.62698 2.43915 7.94536 2.43915V2.43915Z" stroke="#1E53BC" stroke-width="1.5" stroke-miterlimit="10"/>
            <path d="M13.2422 2.70026L7.48032 2.70026V2.65609C7.48032 1.74168 8.22199 1.00001 9.1364 1.00001L11.5861 1.00001C12.5005 1.00001 13.2422 1.74168 13.2422 2.65609V2.70026V2.70026Z" fill="#1E53BC"/>
            <path d="M7.23102 13.0862C7.83862 13.0862 8.33118 12.5936 8.33118 11.986C8.33118 11.3784 7.83862 10.8859 7.23102 10.8859C6.62342 10.8859 6.13086 11.3784 6.13086 11.986C6.13086 12.5936 6.62342 13.0862 7.23102 13.0862Z" fill="#1E53BC"/>
            <path d="M13.5113 13.0862C14.1189 13.0862 14.6114 12.5936 14.6114 11.986C14.6114 11.3784 14.1189 10.8859 13.5113 10.8859C12.9037 10.8859 12.4111 11.3784 12.4111 11.986C12.4111 12.5936 12.9037 13.0862 13.5113 13.0862Z" fill="#1E53BC"/>
            <path d="M4.45654 9.53764H16.2686L15.7075 4.74994H5.37486L4.45654 9.53764Z" fill="#1E53BC"/>
            <path d="M10.3623 4.43817V9.53761" stroke="white" stroke-width="1.5" stroke-miterlimit="10"/>
          </svg>
          Travelski night express
        </div>
      </div>
    </div>
    
    <div class="d-flex">
      <div class="timeline-visual-mobile d-flex flex-column align-items-center me-3">
        <div class="timeline-point-mobile"></div>
      </div>
      <div class="timeline-content-mobile">
        <div class="timeline-text-mobile mb-0"><strong>Arrivée dimanche</strong> matin à Paris</div>
      </div>
    </div>

  </div>

  <!-- Desktop -->
  <div class="timeline-section d-none d-lg-block">

    <div class="timeline-section-title body-strong">
        Détail du travelski night express
    </div>
    
    <div class="timeline-track">
      
      <div class="point">
        <div class="circle"></div>
        <div class="label-bottom subcaption">
          <strong>Départ vendredi</strong><br>soir de Paris
        </div>
      </div>

      <div class="segment">
        <div class="segment-solid"></div>
        <div class="badge-top">
          <span class="custom-badge badge-train m-0 p-1 px-2 subcaption-strong">
            <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.28809 14.35H15.4363V14.3942C15.4363 15.3086 14.6946 16.0503 13.7802 16.0503H6.94417C6.02975 16.0503 5.28809 15.3086 5.28809 14.3942V14.35Z" fill="#1E53BC"/>
              <path d="M6.96318 15.7891L4.16797 19" stroke="#1E53BC" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
              <path d="M13.7603 15.7891L16.5555 19" stroke="#1E53BC" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
              <path d="M5.03467 17.7284H15.6894" stroke="#1E53BC" stroke-width="1.5" stroke-miterlimit="10"/>
              <path d="M7.94536 2.43915H12.798C14.1203 2.43915 15.2477 3.48345 15.4633 4.90704L16.6856 11.4028C16.957 13.1991 15.688 14.8305 14.0203 14.8305H6.70232C5.03065 14.8305 3.76034 13.1913 4.0383 11.3924L5.28134 4.89794C5.50085 3.47826 6.62698 2.43915 7.94536 2.43915V2.43915Z" stroke="#1E53BC" stroke-width="1.5" stroke-miterlimit="10"/>
              <path d="M13.2422 2.70026L7.48032 2.70026V2.65609C7.48032 1.74168 8.22199 1.00001 9.1364 1.00001L11.5861 1.00001C12.5005 1.00001 13.2422 1.74168 13.2422 2.65609V2.70026V2.70026Z" fill="#1E53BC"/>
              <path d="M7.23102 13.0862C7.83862 13.0862 8.33118 12.5936 8.33118 11.986C8.33118 11.3784 7.83862 10.8859 7.23102 10.8859C6.62342 10.8859 6.13086 11.3784 6.13086 11.986C6.13086 12.5936 6.62342 13.0862 7.23102 13.0862Z" fill="#1E53BC"/>
              <path d="M13.5113 13.0862C14.1189 13.0862 14.6114 12.5936 14.6114 11.986C14.6114 11.3784 14.1189 10.8859 13.5113 10.8859C12.9037 10.8859 12.4111 11.3784 12.4111 11.986C12.4111 12.5936 12.9037 13.0862 13.5113 13.0862Z" fill="#1E53BC"/>
              <path d="M4.45654 9.53764H16.2686L15.7075 4.74994H5.37486L4.45654 9.53764Z" fill="#1E53BC"/>
              <path d="M10.3623 4.43817V9.53761" stroke="white" stroke-width="1.5" stroke-miterlimit="10"/>
            </svg>
           Travelski night express
          </span>
        </div>
      </div>

      <div class="point">
        <div class="circle"></div>
        <div class="label-bottom subcaption">
          <strong>Arrivée samedi</strong><br>matin à la gare
        </div>
      </div>

      <div class="segment">
        <div class="segment-dotted"></div>
        <div class="badge-top">
          <span class="custom-badge badge-transfer m-0 p-1 px-2 subcaption-strong">
            <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.7196 2H4.90152C3.96864 2 3.2124 2.75624 3.2124 3.68911V14.9472C3.2124 15.8801 3.96864 16.6363 4.90152 16.6363H14.7196C15.6525 16.6363 16.4087 15.8801 16.4087 14.9472V3.68911C16.4087 2.75624 15.6525 2 14.7196 2Z" stroke="#0D141B" stroke-width="1.5" stroke-miterlimit="10"/>
              <path d="M17 5.53626V8.53625H19V5.53626H17Z" stroke="#0D141B" stroke-width="1.5" stroke-linejoin="round"/>
              <path d="M1 5.53626L1 8.53625H3V5.53626H1Z" stroke="#0D141B" stroke-width="1.5" stroke-linejoin="round"/>
              <path d="M16.4087 4.81915H3.2124V11.1941H16.4087V4.81915Z" fill="#0D141B"/>
              <path d="M12.2344 16.7516H14.5422V17.9717C14.5422 18.5798 14.048 19.0726 13.4413 19.0726H13.3366C12.7285 19.0726 12.2357 18.5785 12.2357 17.9717V16.7516H12.2344Z" stroke="#0D141B" stroke-width="1.5" stroke-miterlimit="10"/>
              <path d="M5.0166 16.7516H7.3244V17.9717C7.3244 18.5798 6.83025 19.0726 6.22349 19.0726H6.11883C5.51075 19.0726 5.01793 18.5785 5.01793 17.9717V16.7516H5.0166Z" stroke="#0D141B" stroke-width="1.5" stroke-miterlimit="10"/>
              <path d="M9.81104 4.36609V11.7134" stroke="white" stroke-width="1.5" stroke-miterlimit="10"/>
              <path d="M8.77783 13.7086H10.8737" stroke="#0D141B" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
              <path d="M6.04206 14.9181C6.71007 14.9181 7.2516 14.3766 7.2516 13.7086C7.2516 13.0406 6.71007 12.499 6.04206 12.499C5.37405 12.499 4.83252 13.0406 4.83252 13.7086C4.83252 14.3766 5.37405 14.9181 6.04206 14.9181Z" fill="#0D141B"/>
              <path d="M13.6094 14.9181C14.2775 14.9181 14.819 14.3766 14.819 13.7086C14.819 13.0406 14.2775 12.499 13.6094 12.499C12.9414 12.499 12.3999 13.0406 12.3999 13.7086C12.3999 14.3766 12.9414 14.9181 13.6094 14.9181Z" fill="#0D141B"/>
            </svg>
            Transfert jusqu'à l'hébergement
          </span>
        </div>
      </div>

      <div class="point">
        <div class="circle filled"></div>
        <div class="label-bottom subcaption">
          <strong>Dépose des valises</strong><br>et récupération des skis
        </div>
      </div>

      <div class="segment">
        <div class="segment-solid"></div>
        <div class="badge-top">
          <span class="custom-badge badge-stay m-0 p-1 px-2 subcaption-strong">
            <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2.28955 6.72662L17.7743 9.89399" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
              <path d="M3.89804 5.8291L3.32324 8.2443" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
              <path d="M1.4668 11.8024L14.163 18.2985C15.0525 18.7506 16.1354 18.5359 16.7862 17.7784L17.5797 16.8556" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
              <path d="M16.9114 4.51811C17.8829 4.51811 18.6705 3.73056 18.6705 2.75906C18.6705 1.78756 17.8829 1 16.9114 1C15.9399 1 15.1523 1.78756 15.1523 2.75906C15.1523 3.73056 15.9399 4.51811 16.9114 4.51811Z" fill="white"/>
              <path d="M14.6683 5.08755C14.2615 4.12733 13.1533 3.67923 12.1931 4.08599L8.63096 5.59566C7.72809 5.97841 7.27866 6.9813 7.56672 7.8975C7.59873 8.03087 7.65474 8.1589 7.73476 8.27759C7.81344 8.41495 7.90813 8.54031 8.01482 8.64967L10.2313 11.5583L7.44536 12.6732C6.84389 12.9133 6.55183 13.5961 6.79322 14.1962C6.97592 14.655 7.41602 14.9337 7.88146 14.9337C8.02682 14.9337 8.17352 14.9071 8.31622 14.8497L12.5638 13.1507C12.9079 13.0133 13.1666 12.7212 13.2613 12.3625C13.356 12.0051 13.276 11.6223 13.0453 11.3329L11.0075 8.68968L13.6681 7.56143C14.6283 7.15467 15.0764 6.04643 14.6696 5.08621L14.6683 5.08755Z" fill="white"/>
            </svg>
            Séjour du samedi au samedi
          </span>
        </div>
      </div>

      <div class="point">
        <div class="circle filled"></div>
        <div class="label-bottom subcaption">
          <strong>Skiez jusqu'à</strong><br>la dernière minute
        </div>
      </div>

      <div class="segment">
        <div class="segment-dotted"></div>
        <div class="badge-top">
          <span class="custom-badge badge-transfer m-0 p-1 px-2 subcaption-strong">
            <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.7196 2H4.90152C3.96864 2 3.2124 2.75624 3.2124 3.68911V14.9472C3.2124 15.8801 3.96864 16.6363 4.90152 16.6363H14.7196C15.6525 16.6363 16.4087 15.8801 16.4087 14.9472V3.68911C16.4087 2.75624 15.6525 2 14.7196 2Z" stroke="#0D141B" stroke-width="1.5" stroke-miterlimit="10"/>
              <path d="M17 5.53626V8.53625H19V5.53626H17Z" stroke="#0D141B" stroke-width="1.5" stroke-linejoin="round"/>
              <path d="M1 5.53626L1 8.53625H3V5.53626H1Z" stroke="#0D141B" stroke-width="1.5" stroke-linejoin="round"/>
              <path d="M16.4087 4.81915H3.2124V11.1941H16.4087V4.81915Z" fill="#0D141B"/>
              <path d="M12.2344 16.7516H14.5422V17.9717C14.5422 18.5798 14.048 19.0726 13.4413 19.0726H13.3366C12.7285 19.0726 12.2357 18.5785 12.2357 17.9717V16.7516H12.2344Z" stroke="#0D141B" stroke-width="1.5" stroke-miterlimit="10"/>
              <path d="M5.0166 16.7516H7.3244V17.9717C7.3244 18.5798 6.83025 19.0726 6.22349 19.0726H6.11883C5.51075 19.0726 5.01793 18.5785 5.01793 17.9717V16.7516H5.0166Z" stroke="#0D141B" stroke-width="1.5" stroke-miterlimit="10"/>
              <path d="M9.81104 4.36609V11.7134" stroke="white" stroke-width="1.5" stroke-miterlimit="10"/>
              <path d="M8.77783 13.7086H10.8737" stroke="#0D141B" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
              <path d="M6.04206 14.9181C6.71007 14.9181 7.2516 14.3766 7.2516 13.7086C7.2516 13.0406 6.71007 12.499 6.04206 12.499C5.37405 12.499 4.83252 13.0406 4.83252 13.7086C4.83252 14.3766 5.37405 14.9181 6.04206 14.9181Z" fill="#0D141B"/>
              <path d="M13.6094 14.9181C14.2775 14.9181 14.819 14.3766 14.819 13.7086C14.819 13.0406 14.2775 12.499 13.6094 12.499C12.9414 12.499 12.3999 13.0406 12.3999 13.7086C12.3999 14.3766 12.9414 14.9181 13.6094 14.9181Z" fill="#0D141B"/>
            </svg>
            Transfert jusqu'à la gare
          </span>
        </div>
      </div>

      <div class="point">
        <div class="circle"></div>
        <div class="label-bottom subcaption">
          <strong>Départ samedi</strong><br>soir de la station
        </div>
      </div>

      <div class="segment">
        <div class="segment-solid"></div>
        <div class="badge-top">
          <span class="custom-badge badge-train m-0 p-1 px-2 subcaption-strong">
            <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.28809 14.35H15.4363V14.3942C15.4363 15.3086 14.6946 16.0503 13.7802 16.0503H6.94417C6.02975 16.0503 5.28809 15.3086 5.28809 14.3942V14.35Z" fill="#1E53BC"/>
              <path d="M6.96318 15.7891L4.16797 19" stroke="#1E53BC" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
              <path d="M13.7603 15.7891L16.5555 19" stroke="#1E53BC" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
              <path d="M5.03467 17.7284H15.6894" stroke="#1E53BC" stroke-width="1.5" stroke-miterlimit="10"/>
              <path d="M7.94536 2.43915H12.798C14.1203 2.43915 15.2477 3.48345 15.4633 4.90704L16.6856 11.4028C16.957 13.1991 15.688 14.8305 14.0203 14.8305H6.70232C5.03065 14.8305 3.76034 13.1913 4.0383 11.3924L5.28134 4.89794C5.50085 3.47826 6.62698 2.43915 7.94536 2.43915V2.43915Z" stroke="#1E53BC" stroke-width="1.5" stroke-miterlimit="10"/>
              <path d="M13.2422 2.70026L7.48032 2.70026V2.65609C7.48032 1.74168 8.22199 1.00001 9.1364 1.00001L11.5861 1.00001C12.5005 1.00001 13.2422 1.74168 13.2422 2.65609V2.70026V2.70026Z" fill="#1E53BC"/>
              <path d="M7.23102 13.0862C7.83862 13.0862 8.33118 12.5936 8.33118 11.986C8.33118 11.3784 7.83862 10.8859 7.23102 10.8859C6.62342 10.8859 6.13086 11.3784 6.13086 11.986C6.13086 12.5936 6.62342 13.0862 7.23102 13.0862Z" fill="#1E53BC"/>
              <path d="M13.5113 13.0862C14.1189 13.0862 14.6114 12.5936 14.6114 11.986C14.6114 11.3784 14.1189 10.8859 13.5113 10.8859C12.9037 10.8859 12.4111 11.3784 12.4111 11.986C12.4111 12.5936 12.9037 13.0862 13.5113 13.0862Z" fill="#1E53BC"/>
              <path d="M4.45654 9.53764H16.2686L15.7075 4.74994H5.37486L4.45654 9.53764Z" fill="#1E53BC"/>
              <path d="M10.3623 4.43817V9.53761" stroke="white" stroke-width="1.5" stroke-miterlimit="10"/>
            </svg>
            Travelski night express
          </span>
        </div>
      </div>

      <div class="point">
        <div class="circle"></div>
        <div class="label-bottom subcaption">
          <strong>Arrivée dimanche</strong><br>matin à Paris
        </div>
      </div>

    </div>
  </div>

  
  
</template>

<script setup lang="ts">

</script>

<style scoped>



/* Conteneur principal */
.timeline-container-mobile {
  background-color: #e2e8f4;
  border-radius: 16px;
  padding: 30px 20px;
  max-width: 450px;
  font-family: system-ui, -apple-system, sans-serif;
  margin: 20px auto;
}

.timeline-title-mobile {
  font-weight: 900;
  font-size: 1.4rem;
  color: #212529;
  margin-bottom: 30px;
  letter-spacing: -0.5px;
}

/* --- Colonne Visuelle (Traits et points) --- */
.timeline-visual-mobile {
  min-width: 24px;
}

.timeline-point-mobile {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 2px solid var(--primary-blue);
  background-color: #e2e8f4;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 4px;
}

.timeline-point-mobile::after {
  content: '';
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: var(--primary-blue);
}

.timeline-line-mobile {
  width: 2px;
  margin-top: 4px;
  margin-bottom: -16px;
}

.line-solid-mobile {
  background-color: var(--primary-blue);
}

.line-dotted-mobile {
  background-color: transparent;
  border-left: 3px dotted var(--primary-white);
  width: 3px;
}

/* --- Contenu et Textes --- */
.timeline-text-mobile {
  font-size: 0.95rem;
  color: #212529;
  line-height: 1.4;
  margin-bottom: 12px;
}

/* --- Badges --- */
.custom-badge-mobile {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 16px;
  border-radius: 50px;
  font-size: 0.85rem;
  font-weight: 700;
}

.badge-train-mobile {
  background-color: var(--primary-white);
  color: var(--primary-blue);
  border: 1px solid var(--primary-white); 
}

.badge-transfer-mobile {
  background-color: transparent;
  color: #111111;
  border: 1px solid var(--primary-blue);
}

.badge-stay-mobile {
  background-color: var(--blue-800);
  color: var(--primary-white);
  border: 1px solid var(--blue-800);
}




@media only screen and (min-width: 960px) {

  /* Conteneur principal avec la couleur de fond de l'image */
  .timeline-section {
    background-color: var(--blue-200);
    padding: 70px 60px 60px 60px;
    overflow: none;
    border-radius: 24px;
  }

  .timeline-section-title {
    position: relative;
    top: -45px;
    left: -40px;
  }

  .timeline-track {
    display: flex;
    align-items: center;
    width: 100%;
    min-width: 950px; /* Force une largeur minimale pour éviter l'écrasement */
    max-width: 1300px;
    margin: 0 auto;
  }

  /* --- Nœuds (Points) --- */
  .point {
    position: relative;
    z-index: 2;
    display: flex;
    justify-content: center;
  }

  .circle {
    width: 14px;
    height: 14px;
    border-radius: 50%;
    border: 2px solid var(--primary-blue);
    background-color: var(--primary-white);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /* Le petit point bleu à l'intérieur des cercles vides */
  .circle::after {
    content: '';
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background-color: var(--primary-blue);
  }

  /* Cercles pleins pour les étapes centrales */
  .circle.filled {
    background-color: var(--primary-blue);
  }
  .circle.filled::after {
    display: none; /* Cache le petit point interne */
  }

  /* --- Segments de ligne --- */
  .segment {
    flex-grow: 1;
    position: relative;
    height: 14px; /* Même hauteur que les cercles pour l'alignement vertical */
    display: flex;
    align-items: center;
    z-index: 1;
  }

  .segment-solid {
    width: 100%;
    height: 2px;
    background-color: var(--primary-blue);
  }

  .segment-dotted {
    width: 100%;
    border-top: 3.5px dotted var(--primary-white);
  }

  /* --- Textes et Badges --- */
  .label-bottom {
    position: absolute;
    top: 25px;
    text-align: center;
    color: var(--grey-900);
    white-space: nowrap;
    line-height: 1.4;
  }

  .badge-top {
    position: absolute;
    bottom: 22px;
    left: 50%;
    transform: translateX(-50%);
    white-space: nowrap;
  }

  .custom-badge {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    border-radius: 50px;
  }

  /* Styles spécifiques aux différents badges */
  .badge-train {
    background-color: var(--primary-white);
    color: var(--primary-blue);
  }

  .badge-transfer {
    background-color: transparent;
    color: #212529;
    border: 1px solid #8da6ce;
  }

  .badge-stay {
    background-color: var(--blue-800);
    color: var(--primary-white);
    border: 1px solid var(--blue-800);
  }
}
</style>
